import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { media } from '@atlaskit/primitives/responsive';

const outerWrapperStyle = css({
	position: 'relative',
	boxSizing: 'border-box',
	clear: 'both',
	display: 'block',
	midWith: '100%',
	paddingBlockEnd: '32px',
	paddingBlockStart: '96px',
});

const rowWrapperStyle = css({
	boxSizing: 'border-box',
	display: 'flex',
	flexWrap: 'wrap',
	marginInlineEnd: 'auto',
	marginInlineStart: 'auto',
	maxWidth: '1440px',
});

const columnStyle = css({
	position: 'relative',
	boxSizing: 'border-box',
	display: 'block',
	flexDirection: 'column',
	float: 'left',
	minHeight: '1px',
	padding: '16px',
	textAlign: 'center',
	width: '66.66666%',
	[media.below.sm]: {
		width: '100%',
	},
	[media.only.sm]: {
		marginInlineStart: '16.66666%',
	},
	[media.above.sm]: {
		marginInlineStart: '16.66666%',
	},
});

const headerTextStyle = css({
	boxSizing: 'border-box',
	display: 'block',
	marginBlockEnd: '24px',
	fontFamily: `"Charlie Display", -apple-system, "system-ui", "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`,
	fontSize: '3rem',
	fontWeight: '500',
	letterSpacing: 'normal',
	lineHeight: '3.5rem',
	textAlign: 'center',
	verticalAlign: 'baseline',
	color: '#253858',
	[media.only.md]: {
		fontSize: '2.75rem',
		lineHeight: '1.18181818',
		marginBlockEnd: '16px',
	},
	[media.only.sm]: {
		fontSize: '2.75rem',
		lineHeight: '1.18181818',
		marginBlockEnd: '16px',
	},
	[media.below.sm]: {
		fontSize: '2rem',
		lineHeight: '1.25',
		marginBlockEnd: '14px',
	},
});

const descriptionTextSytle = css({
	boxSizing: 'border-box',
	display: 'block',
	fontFamily: `"Charlie Display", -apple-system, "system-ui", "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`,
	fontSize: '1.25rem',
	fontWeight: '400',
	letterSpacing: '.3px',
	lineHeight: '1.4',
	textAlign: 'center',
	verticalAlign: 'baseline',
	color: '#42526e',
});

const imageStyle = css({
	boxSizing: 'border-box',
	display: 'inline',
	textAlign: 'center',
	height: '162px',
	marginBlockEnd: '16px',
	maxWidth: '100%',
	overflowX: 'clip',
	overflowY: 'clip',
	width: '280px',
	overflowClipMargin: 'content-box',
	borderImageRepeat: 'stretch',
	borderImageSlice: '100%',
});

export const HeroImage = () => {
	return (
		// eslint-disable-next-line no-restricted-syntax
		<img
			css={imageStyle}
			src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Ticket_created@2x_1.webp"
			alt="Ticket"
		/>
	);
};

const Hero = () => {
	const intl = useIntl();
	const headerText = intl.formatMessage({
		id: 'enterpriseContactThanksPage.message-recieved',
		defaultMessage: 'Message received',
	});
	const descriptionTicketText = intl.formatMessage({
		id: 'enterpriseContactThanksPage.creating-ticket',
		defaultMessage:
			'Our sales team is creating a ticket and will email you within 2 business days.',
	});

	const descriptionResourcesText = intl.formatMessage({
		id: 'enterpriseContactThanksPage.resources-to-start',
		defaultMessage: 'In the meantime, here are some resources to get you started.',
	});

	return (
		<div css={outerWrapperStyle}>
			<div css={rowWrapperStyle}>
				<div css={columnStyle}>
					<HeroImage />
					<div css={headerTextStyle}>{headerText}</div>
					<div css={descriptionTextSytle}>
						{descriptionTicketText}
						<br />
						{descriptionResourcesText}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Hero;
